module.exports = __webpack_public_path__ + "img/0x9b049f1283515eef1d3f6ac610e1595ed25ca3e9.2729f2bb.png";